module.exports = __webpack_public_path__ + "static/David_Cescon_headshot_lores-67ce424516607c9eced7ff5b2abb3bd0.png";